import { FC, forwardRef } from 'react'
import { ICalColor, CalendarColorName, ColorPaletteMap } from './PMCalendar.Common'
import { Menu, MenuTrigger, MenuPopover, MenuList, MenuItem, MenuTriggerChildProps } from '@fluentui/react-components'
import { useDispatch } from 'react-redux'
import { setCalendarInfoForProject } from '@/actions/uiActions'

interface IColorDotProps extends Partial<MenuTriggerChildProps> {
  color: ICalColor
}
const ColorDot = forwardRef<HTMLDivElement, IColorDotProps>(({ color, ...rest }, ref) => (
  <div
    className="mr-2 h-4 min-h-4 w-4 min-w-4 rounded-full"
    style={{ backgroundColor: color.colorBg }}
    ref={ref}
    {...rest}
  />
))

interface IColorButtonProps {
  color: CalendarColorName
  idd: number
}

export const ColorButton: FC<IColorButtonProps> = ({ color, idd }) => {
  const dispatch = useDispatch()
  const calColor = ColorPaletteMap[color]
  const onClickCreate = (colorName: CalendarColorName) => () =>
    dispatch(setCalendarInfoForProject({ idd, color: colorName }))
  const menuItems = Object.values(CalendarColorName).map(colorName => (
    <MenuItem key={colorName} onClick={onClickCreate(colorName)}>
      <div className="flex flex-row">
        <ColorDot color={ColorPaletteMap[colorName]} />
        <span>{colorName}</span>
      </div>
    </MenuItem>
  ))
  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <ColorDot color={calColor} />
      </MenuTrigger>
      <MenuPopover>
        <MenuList>{menuItems}</MenuList>
      </MenuPopover>
    </Menu>
  )
}
